// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#title{
    width: 100%;
    display: flex;
    justify-content: center;

    font-size: 3em;
    font-weight: 750;
    text-decoration: underline;
    margin-bottom: 45px;
    /*border: 1px solid black;*/
}

#main-content{
    width: 100%;
    margin-top: 25px;
    display: flex;
    justify-content: center;
    /*border: 1px solid black;*/
}

.contact-component{
    /*border: 1px solid aqua;*/
    color: #012D26;
}

#form-title{
    font-size: 2em;
    font-weight: 650;
    margin-bottom: 25px;
}

#information-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 97%;
    margin-left: 3%;
    margin-top: 100px;
}

.information-icon-container{
    width: 80px;
    height: 80px;
    margin-bottom: 3%;
    /*border: 1px solid black;*/
}

.information-title{
    font-size: 1.6em;
    font-weight: 750;
    margin-bottom: 25px;
}

.information-text{
    width: 90%;
    font-size: 1.37em;
    font-weight: 450;
}

#location-pin-container{
    width: 60px;
    height: 80px;
}

#office-location-info{
    margin-top: 15px;
}

.form-component{
    margin-bottom: 17px;
}

.input-title{
    font-size: 1.3em;
    font-weight: 500;
    margin-bottom: 10px;
    /*border: 1px solid #D7ECE1;*/
}

.text-input{
    width: 77.8%;
    height: 35px;
    padding-left: 10px;
    font-size: 1.1em;
    border: 2px solid #e2e2e2;
    color: #012D26;
}

#needs{
    width: 70%;
    margin-left: 5%;
    /*border: 1px solid #D7ECE1;*/
}

.checkbox-container{
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 2%;
    /*border: 1px solid #D7ECE1;*/
}

.checkbox{
    font-size: 2em;
    width: 5%;
    height: 20px;
    margin-right: 3%;
}

.checkbox-description{
    height: 100%;
}

textarea{
    width: 75%;
    height: 150px;
    padding: 5px;
    border: 2px solid #ccc;
    font-size: 1.15em;
    font-family: raleway, sans-serif;
    resize: none;
}

.email-icon-container{
    width: 70px;
    height: 50px;
    margin-bottom: 10px;
}

/*Image*/
.image{
    width: 100%;
    height: 100%;
}

#submitBtn{
    outline: none;
    width: 35%;
    height: 37px;
    background: #ffffff;
    border: 1px solid #E65924;
    color: #E65924;
    border-radius: 15px;
}

#submitBtn:hover{
    transition: 455ms all;
    color: #ffffff;
    background: #E65924;
}

#submitBtn:disabled{
    color: #ffffff;
    background: #dddddd;
    border: 1px solid #dddddd;

}`, "",{"version":3,"sources":["webpack://./src/App/Page/Contact/contact.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;;IAEvB,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,SAAS;IACT,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,QAAQ;AACR;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;;AAE7B","sourcesContent":["#title{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    font-size: 3em;\r\n    font-weight: 750;\r\n    text-decoration: underline;\r\n    margin-bottom: 45px;\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n#main-content{\r\n    width: 100%;\r\n    margin-top: 25px;\r\n    display: flex;\r\n    justify-content: center;\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.contact-component{\r\n    /*border: 1px solid aqua;*/\r\n    color: #012D26;\r\n}\r\n\r\n#form-title{\r\n    font-size: 2em;\r\n    font-weight: 650;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n#information-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    width: 97%;\r\n    margin-left: 3%;\r\n    margin-top: 100px;\r\n}\r\n\r\n.information-icon-container{\r\n    width: 80px;\r\n    height: 80px;\r\n    margin-bottom: 3%;\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.information-title{\r\n    font-size: 1.6em;\r\n    font-weight: 750;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.information-text{\r\n    width: 90%;\r\n    font-size: 1.37em;\r\n    font-weight: 450;\r\n}\r\n\r\n#location-pin-container{\r\n    width: 60px;\r\n    height: 80px;\r\n}\r\n\r\n#office-location-info{\r\n    margin-top: 15px;\r\n}\r\n\r\n.form-component{\r\n    margin-bottom: 17px;\r\n}\r\n\r\n.input-title{\r\n    font-size: 1.3em;\r\n    font-weight: 500;\r\n    margin-bottom: 10px;\r\n    /*border: 1px solid #D7ECE1;*/\r\n}\r\n\r\n.text-input{\r\n    width: 77.8%;\r\n    height: 35px;\r\n    padding-left: 10px;\r\n    font-size: 1.1em;\r\n    border: 2px solid #e2e2e2;\r\n    color: #012D26;\r\n}\r\n\r\n#needs{\r\n    width: 70%;\r\n    margin-left: 5%;\r\n    /*border: 1px solid #D7ECE1;*/\r\n}\r\n\r\n.checkbox-container{\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    margin-top: 2%;\r\n    /*border: 1px solid #D7ECE1;*/\r\n}\r\n\r\n.checkbox{\r\n    font-size: 2em;\r\n    width: 5%;\r\n    height: 20px;\r\n    margin-right: 3%;\r\n}\r\n\r\n.checkbox-description{\r\n    height: 100%;\r\n}\r\n\r\ntextarea{\r\n    width: 75%;\r\n    height: 150px;\r\n    padding: 5px;\r\n    border: 2px solid #ccc;\r\n    font-size: 1.15em;\r\n    font-family: raleway, sans-serif;\r\n    resize: none;\r\n}\r\n\r\n.email-icon-container{\r\n    width: 70px;\r\n    height: 50px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n/*Image*/\r\n.image{\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n#submitBtn{\r\n    outline: none;\r\n    width: 35%;\r\n    height: 37px;\r\n    background: #ffffff;\r\n    border: 1px solid #E65924;\r\n    color: #E65924;\r\n    border-radius: 15px;\r\n}\r\n\r\n#submitBtn:hover{\r\n    transition: 455ms all;\r\n    color: #ffffff;\r\n    background: #E65924;\r\n}\r\n\r\n#submitBtn:disabled{\r\n    color: #ffffff;\r\n    background: #dddddd;\r\n    border: 1px solid #dddddd;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
